import styles from './SectionSubtitle.module.scss';

export default function SectionSubtitle({ children, ...props }) {
    return (
        <h3 className={styles.subtitle} {...props}>{children}</h3>
    );
  }